import { AjaxClient } from "app/common/ajax";
import { MessageDisplay } from "app/common/message_display";
import * as $ from "jquery";

// A note on the 'any's in this file: The plugin we use is jquery.flot.
// It's on npm, but it's stack and time sub-plugins aren't. Neither is there an @types.
// If we want to do this properly, maybe get a more recently maintained library.
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
export class Stats {
    private readonly options: any = {
        series: {
            lines: {
                show: true,
                fill: true
            },
            points: { show: true },
            stack: true
        },
        xaxis: {
            mode: 'time',
            timeformat: '%Y/%m/%d'
        }
    };

    private readonly ajaxClient: AjaxClient;
    private readonly chart: any;
    private readonly messageDisplay: MessageDisplay;

    public constructor(ajaxClient: AjaxClient, messageDisplay: MessageDisplay) {
        this.ajaxClient = ajaxClient;
        this.messageDisplay = messageDisplay;

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.chart = ($ as any).plot($('#chart'), [], this.options);

        $('#chart-wrapper').addClass('loading');
        void this.ajaxClient.call<IStatsApiAjaxResult>('/modpanel/stats/api').then(
            (result: IStatsApiAjaxResult) => this.populate(result),
            (reason: string) => this.messageDisplay.error(reason)
        );
    }

    private populate(result: IStatsApiAjaxResult) {
        this.chart.setData(result.data);
        this.chart.setupGrid();
        this.chart.draw();
        $('#chart-wrapper').removeClass('loading');
    }
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/* eslint-enable @typescript-eslint/no-unsafe-call */

interface IStatsApiAjaxResult {
    data: IStatsApiDataAjaxResult[];
}

interface IStatsApiDataAjaxResult {
    label: string;
    data: number[][];
}
